if (!customElements.get('saving-calculator')) {
  class SavingCalculator extends HTMLElement {
    constructor() {
      super();

      // this.offset = -0.3;
    }

    calculate() {
      const currentCost = this.perClient.value * this.dataset.averageCost * this.clients.value;
      const newCost = this.clients.value * this.dataset.cost;

      const diff = currentCost - newCost;
      const percentageSaved = (newCost / currentCost) * 100;

      this.price.innerHTML = this.dataset.price.replace(/{{.*}}/g, diff.toFixed(2));
      this.percentage.innerHTML = percentageSaved.toPrecision(4) + '%';
    }

    handleClientsInputEvent(event) {
      this.calculate();
      let target = event.target;
      let newPoint = (target.value / target.getAttribute('max')) * 100;
      this.rangeValueSpan.innerHTML = target.value;
      this.rangeValueSpan.style.left = `calc(${newPoint}% + (${1 - newPoint * 0.5}px))`;
    }

    connectedCallback() {
      this.price = this.querySelector('.js-calculator-price');
      this.percentage = this.querySelector('.js-calculator-percentage');
      this.rangeValueSpan = this.querySelector('.js-output');

      this.clients = this.querySelector('.js-calculator-clients');
      if (this.clients) this.clients.addEventListener('input', this.handleClientsInputEvent.bind(this));

      this.perClient = this.querySelector('.js-calculator-per-client');
      if (this.perClient) this.perClient.addEventListener('input', this.calculate.bind(this));

      this.handleClientsInputEvent({ target: this.clients });
      this.calculate();
    }
  }
  customElements.define('saving-calculator', SavingCalculator);
}
600 * 1.34;
